import AccessDeniedPage from '@/modules/auth/access/AccessDeniedPage';
import ErrorPage from '@/modules/auth/error/ErrorPage';
import ForgetPassword from '@/modules/auth/forget/ForgotPasswordPage';
import LoginPage from '@/modules/auth/login/LoginPage';
import ResetPage from '@/modules/auth/reset/ResetPage';

export const authRoutes = [
  {
    path: 'auth',
    children: [
      {
        path: 'access',
        Component: AccessDeniedPage,
      },
      {
        path: 'error',
        Component: ErrorPage,
      },
      {
        path: 'forget',
        Component: ForgetPassword,
      },
      {
        path: 'login',
        Component: LoginPage,
      },
      {
        path: 'reset',
        Component: ResetPage,
      },
    ],
  },
];
